import { dispatchEvent, EventKey } from '@tgg/services';

import { getESpotTexture } from './ESpotsSlide.helpers';
import {
    StyledContainer,
    StyledTextureWrapper,
    StyledTitle,
} from './ESpotsSlide.styled';
import { ESpotsSlideProperties } from './ESpotsSlide.types';

export const ESpotsSlide = ({
    title,
    textureStyle,
    link,
    slideColor,
    textureColor,
    slidePosition,
    eSpotsCount,
}: ESpotsSlideProperties) => {
    const texture = getESpotTexture(textureStyle);

    return (
        <StyledContainer
            as={link ? 'a' : 'div'}
            href={link}
            $slideColor={slideColor}
            $isClickable={!!link}
            onClick={() =>
                link &&
                dispatchEvent(EventKey.ESPOT_INTERACTION, {
                    link_text: title,
                    link_destination: link,
                    component_name: 'espot',
                    espot_position: `${slidePosition}/${eSpotsCount}`,
                })
            }
        >
            {textureColor && (
                <StyledTextureWrapper
                    $textureColor={textureColor}
                    $slideColor={slideColor}
                >
                    {texture}
                </StyledTextureWrapper>
            )}
            <StyledTitle>{title}</StyledTitle>
        </StyledContainer>
    );
};
